// extracted by mini-css-extract-plugin
export default {"container":"Base_container__VJGiZ","container-outlet":"Base_container-outlet__Rl2gj"};